import "./App.css";
import { useContext, useEffect, useMemo, useState } from "react";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Link,
} from "react-router-dom";
import { Modal } from "react-bootstrap";
import { employeeRoutes } from "./AppConfig";
import Dashboard from "./pages/dashboard/Dashboard";
import { UserContext } from "./context/UserDetails";

// ----------------- Confirmation Popup -----------------
const ConfirmationPopup = ({ open, title, message, onConfirm }) => (
  <Modal
    show={open}
    onHide={onConfirm}
    size="md"
    centered
    className="custom-backdrop"
  >
    <Modal.Header closeButton={false}>
      <Modal.Title>
        <h5 className="ModalHeader mb-0">{title}</h5>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="mb-4 col-md-12">
        <div className="alert alert-danger mb-0 p-2 d-flex align-items-center">
          <span
            className="material-icons text-danger me-2"
            style={{ fontSize: "1.8rem" }}
          >
            warning
          </span>
          <strong>{message}</strong>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="d-flex justify-content-end w-100">
        {/* <button className="primaryButton" onClick={onConfirm}>
          OK
        </button> */}
        <ul class="List-Button">
          <li class="ListBtnItems">
            <Link
              onClick={onConfirm}
              className="primaryButton "
              variant="primary"
            >
              OK
            </Link>
          </li>
        </ul>
      </div>
    </Modal.Footer>
  </Modal>
);

// helper to match a route path (supports params like :id)
const pathMatches = (routePath, currentPath) => {
  if (!routePath) return false;
  // normalize: ensure both start with "/"
  const normRoute = routePath.startsWith("/") ? routePath : `/${routePath}`;
  const normCurrent = currentPath.startsWith("/")
    ? currentPath
    : `/${currentPath}`;
  const pattern = new RegExp("^" + normRoute.replace(/:\w+/g, "[^/]+") + "$");
  return pattern.test(normCurrent);
};

const AppEmp = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const userType = Number(user?.user_type);
  const userMenuList = user?.menu_list || [];

  // ----------------- Route Filtering -----------------
  const filteredRoutes = useMemo(() => {
    if (userType === 1) {
      // Admin → access all routes
      return employeeRoutes;
    }

    // Other users → Only menu_list + IndexPage (id 126)
    return employeeRoutes.filter((route) => {
      const routeId = Number(route.id);
      return (
        routeId === 2 ||
        routeId === 49 ||
        routeId === 55 ||
        routeId === 93 ||
        routeId === 126 ||
        routeId === 123 ||
        routeId === 130 ||
        userMenuList.includes(routeId)
      );
    });
  }, [userType, userMenuList]);

  // ----------------- Unauthorized Page Detection -----------------
  useEffect(() => {
    if (userType === 1) return; // Admin can access everything
    // Keep "/" as "/" (don't turn it into empty string)
    const rawPath = location.pathname || "/";
    const currentPath =
      rawPath.endsWith("/") && rawPath !== "/" ? rawPath.slice(0, -1) : rawPath;
    // Determine if current path matches any allowed route path
    const isAuthorized = filteredRoutes.some((r) => {
      if (!r.path) return false; // skip index routes (those have index: true)
      return pathMatches(r.path, currentPath);
    });

    // If it's the root "/" we allow it (Dashboard/index) — if index route exists in filteredRoutes
    const hasIndex = filteredRoutes.some(
      (r) => r.index === true || r.path === "/" || !r.path
    );
    if (currentPath === "/" && hasIndex) {
      // authorized to see dashboard/index
      return;
    }

    if (!isAuthorized) {
      setModalMessage(
        "You don't have permission to access this page. Please contact the administrator."
      );
      setModalOpen(true);
      navigate(-1);
    }
  }, [location.pathname, filteredRoutes, userType]);

  const handleModalClose = () => {
    setModalOpen(false);
    // navigate(-1);
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<Dashboard />}>
          {filteredRoutes.map(({ id, path, element, index }) =>
            index ? (
              <Route key={id} index element={element} />
            ) : (
              <Route key={id} path={path} element={element} />
            )
          )}
        </Route>
      </Routes>

      {/* Unauthorized Access Popup */}
      {modalOpen && (
        <ConfirmationPopup
          open={modalOpen}
          title="Access Denied"
          message={modalMessage}
          onConfirm={handleModalClose}
        />
      )}
    </>
  );
};

export default AppEmp;
